module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"percentage":"- {x} %"},"en":{"percentage":"{x}% OFF"},"es":{"percentage":"- {x} %"},"de":{"percentage":"- {x} %"},"it":{"percentage":"- {x} %"},"nl":{"percentage":"- {x} %"},"pt":{"percentage":"- {x} %"}}')
  delete Component.options._Ctor
}
